// import Relatorios from './Index.vue'
import Permissions from "../../models/Permissions";

const Relatorios = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Relatórios",
  icon: "fa fa-file-pdf-o",
  group: "Utilitários",
  permissions,
};

export default [
  {
    path: "/relatorios",
    name: "Relatorios",
    component: Relatorios,
    meta,
  },
];
